import styled from 'styled-components';

export const ButtonContainer = styled.div`
  margin-top: 40px !important;
  padding: 20px;
  button {
    margin: 5px !important;
  }
`;
